import { companyConstants } from '../_constants';
import { companyService } from '../_services';
import { history } from '../_helpers';
import { alertActions } from './';

export const companyActions = {
  companyCreation,
  companyNotFinishedRemoval
}

function companyCreation(data) {
  let company = data.company.name;

  return dispatch => {
    dispatch(request({company}));

    return companyService.companyCreation(data)
      .then(
        data => {
          history.push({
            pathname: '/signup/user',
            state: {
              cp_uuid: data.company.uuid,
              cp_name: data.company.name
            }
          });
          return dispatch(success(data));
        },
        error => {
          dispatch(alertActions.failure(error));
          return dispatch(failure(error));
        }
      )

    function request(data) {
      return { type: companyConstants.COMPANY_CREATION_REQUEST, data }
    }

    function success(data) {
      return { type: companyConstants.COMPANY_CREATION_SUCCESS, data }
    }

    function failure(error) {
      return { type: companyConstants.COMPANY_CREATION_FAILURE, error }
    }
  }
}

function companyNotFinishedRemoval(data) {
  return dispatch => {
    dispatch(request({data}));

    companyService.companyNotFinishedRemoval(data)
      .then(
        data => {
          dispatch(success(data));
          history.push({
            pathname: '/signup/company',
            state: ""
          });
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.failure(error));
        }
      )

    function request(data) {
      return { type: companyConstants.COMPANY_NOT_FINISHED_REMOVAL_REQUEST, data }
    }

    function success(data) {
      return { type: companyConstants.COMPANY_NOT_FINISHED_REMOVAL_SUCCESS, data }
    }

    function failure(error) {
      return { type: companyConstants.COMPANY_NOT_FINISHED_REMOVAL_FAILURE, error }
    }
  }
}